import axios from "axios";
import { API_URL } from "../../constants";

export default {
  getAllMenu: () => {
    return axios.get(API_URL.MENU, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
  userBasedMenu: (id) => {
    return axios.get(`${API_URL.USER_MENU}/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    });
  },
};
